var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from "react";
import styled from "styled-components";
import { SortIcon } from "../../Icons/SortIcon";
var SortIconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  padding-left: 8px;\n  cursor: pointer;\n  svg {\n    vertical-align: text-bottom;\n  }\n"], ["\n  display: inline-block;\n  padding-left: 8px;\n  cursor: pointer;\n  svg {\n    vertical-align: text-bottom;\n  }\n"])));
var DataTableSort = function (props) {
    var id = props.id, className = props.className, style = props.style, onSort = props.onSort;
    return (React.createElement(SortIconWrapper, { id: id, className: className, style: style, onClick: onSort },
        React.createElement(SortIcon, { size: "small" })));
};
export default DataTableSort;
var templateObject_1;
//# sourceMappingURL=DataTableSort.js.map